import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { FunnelDropConnector } from './FunnelDropConnector';
import { FunnelStageBar } from './FunnelStageBar';
import { cn } from '../../lib/utils';

function LegendItem({ swatchClass, style, label }) {
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] text-slate-500">
      <span className={cn('h-2.5 w-4 rounded-sm border border-slate-200', swatchClass)} style={style} />
      {label}
    </span>
  );
}

export function FunnelChart({
  title,
  stages = [],
  selectedStageId,
  onSelectStage,
  className,
}) {
  const maxTotal = Math.max(...stages.map((stage) => Number(stage.total || 0)), 1);
  const worstId = stages.reduce((best, stage) => {
    const dropped = Number(stage.dropped || 0);
    if (!best || dropped > Number(best.dropped || 0)) return stage;
    return best;
  }, null)?.id;

  return (
    <Card className={cn('min-w-0', className)}>
      <CardHeader className="px-4 py-3 sm:px-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <CardTitle>{title}</CardTitle>
          <div className="flex flex-wrap gap-3">
            <LegendItem swatchClass="bg-[var(--brand-primary,#1A428A)]" label="Converted" />
            <LegendItem
              label="Dropped"
              style={{
                backgroundImage:
                  'repeating-linear-gradient(-45deg, #D7E3F4, #D7E3F4 3px, #EEF3FA 3px, #EEF3FA 6px)',
              }}
            />
            <LegendItem
              label="Pending"
              style={{
                backgroundImage:
                  'repeating-linear-gradient(-45deg, #E8D7A8, #E8D7A8 3px, #F6EDD4 3px, #F6EDD4 6px)',
              }}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent className="px-2 py-2 sm:px-3">
        {stages.map((stage, index) => {
          const next = stages[index + 1];
          const showDrop = next && Number(next.dropped || 0) > 0 && !next.unavailable;
          const isWorstDrop = next && next.id === worstId;

          return (
            <React.Fragment key={stage.id}>
              <FunnelStageBar
                stage={stage}
                maxTotal={maxTotal}
                selected={selectedStageId === stage.id}
                isWorst={stage.id === worstId && Number(stage.dropped || 0) > 0}
                onSelect={onSelectStage}
              />
              {showDrop ? (
                <FunnelDropConnector
                  count={Number(next.dropped || 0)}
                  isWorst={isWorstDrop}
                  label={
                    next.droppedLabel
                      || `−${Number(next.dropped || 0).toLocaleString('en-US')} dropped`
                  }
                />
              ) : null}
            </React.Fragment>
          );
        })}
      </CardContent>
    </Card>
  );
}
